import apiClient from '@/services/api-client';
import store from '@/store/index';
import { ERROR_DETAILS } from '.././../constants/error-details';

export default {
	getAllDisclaimerLicenses(userId, organizationId) {
		const endpoint = '/ProfileDisclaimer/GetAllDisclaimers';
		const { profile, companyProfile } = store;
		return apiClient()
			.post(endpoint, {
				userId,
				organizationId,
			})
			.then(({ data }) => data)
			.catch((e) => {
				console.error('license_error: ', e);
			});
	},

	saveAllDisclaimerLicenses(contactId, disclaimers) {
		return apiClient().post('/ProfileDisclaimer/SaveContactDisclaimer', {
			contactId,
			disclaimers,
		});
	},

	/*
	 Disclaimer Logos
	 */

	getComplianceLogos(contactId) {
		const endpoint = '/ProfileDisclaimer/GetComplianceLogos';

		return apiClient()
			.get(endpoint, {
				params: {
					contactId,
				},
			})
			.then(({ data }) => data)
			.catch((e) => {
				console.log('logo_error: ', e);
			});
	},
	saveComplianceLogos(contactId, complianceLogo) {
		const endpoint = '/ProfileDisclaimer/SaveComplianceLogo';

		return apiClient()
			.post(endpoint, {
				contactId,
				complianceLogo,
			})
			.then(({ data }) => data)
			.catch((error) => {
				store.dispatch('showErrorModal', {
					error,
					errorDetails: ERROR_DETAILS.SAVE_COMPLIANCE_LOGO,
				});
			});
	},
};
